import { render, staticRenderFns } from "./inbGr.vue?vue&type=template&id=2c820eea&"
import script from "./inbGr.vue?vue&type=script&lang=js&"
export * from "./inbGr.vue?vue&type=script&lang=js&"
import style0 from "./inbGr.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports